import { motion, useIsPresent } from "framer-motion"
import { useLayoutEffect } from "react"
import Footer from "../components/Footer"
import useGlobalContext from "../context/GlobalContext"
import useWindowsWidth from "../hooks/useWindowsWidth"

const About = () => {
  const isPresent = useIsPresent()
  const { changeCursor } = useGlobalContext()
  const [width] = useWindowsWidth()

  useLayoutEffect(() => {
    window.scroll({ top: 0, behavior: "instant" })
  }, [])

  return (
    <>
      <motion.div
        initial={{ scaleY: 2 }}
        animate={{ scaleY: 0, transition: { duration: 0.5, ease: "circOut" } }}
        exit={{ scaleY: 2, transition: { duration: 0.5, ease: "circIn" } }}
        style={{ originY: isPresent ? 0 : 1 }}
        className="privacy-screen"
      />
      <motion.section className="about" onMouseEnter={() => changeCursor("")}>
        <motion.picture data-scroll-section className="author-img p-relative">
          <motion.h1 className="title proj-title float-txt mix-blend-difference">
            Pixie Autumn
          </motion.h1>
          <source
            type=""
            media="(min-width:1440px)"
            srcSet="/imgs/About/img-lg.jpg"
          ></source>
          <source
            type=""
            media="(min-width:768px)"
            srcSet="/imgs/About/img-md.jpg"
          ></source>
          <source srcSet="/imgs/About/img-sm.jpg"></source>
          <motion.img
            loading="lazy"
            srcSet="/imgs/About/img-sm.jpg"
            alt=""
            decoding="async"
          />
        </motion.picture>
        <motion.div data-scroll-section className="container-sm">
          <div className="author-desc">
            <p className="par-lg uppercase l-auto">
              PixieAutumn IS An IRISH - American DIRECTOR OF PHOTOGRAPHY BASED
              IN LA.
            </p>
            <p className="par-lg uppercase r-auto">
              INTERESTED MAINLY IN NARRATIVE WORK, HIS PROJECTS INCLUDE
              COMMERCIALS FOR DIVERSE LUXURY BRANDS, MUSIC VIDEOS FOR REKNOWN
              AND EMERGING ARTISTS.
            </p>
          </div>
          <div className="flex-col author-refrence">
            <h2 className="title-md uppercase f-normal">REFERENCES</h2>
            <ul className="specs-list flex-col">
              <li className="specs-item flex space-between align-center">
                <span className="color-light">LOUBOUTIN</span>
                <span>RIMOWA</span>
              </li>
              <li className="specs-item flex space-between align-center">
                <span className="color-light">STINK PARIS</span>
                <span>OCURENS</span>
              </li>
              <li className="specs-item flex space-between align-center">
                <span className="color-light">GANG LIFE</span>
                <span>FLEDGE TV</span>
              </li>
              <li className="specs-item flex space-between align-center">
                <span className="color-light">PELICAN</span>
                <span>TRACKX</span>
              </li>
              <li className="specs-item flex space-between align-center">
                <span className="color-light">HERMES</span>
                <span>NEW LIGHT FILMS</span>
              </li>
            </ul>
          </div>
        </motion.div>
        <motion.div data-scroll-section className="author-contact">
          <motion.div className="contact-txt uppercase">
            {width > 768 ? (
              <motion.span
                onMouseEnter={() => changeCursor("hovered")}
                onMouseLeave={() => changeCursor("")}
                className="contact-title"
              >
                contact contact contact contact contact contact &nbsp;
              </motion.span>
            ) : (
              <motion.span
                onMouseEnter={() => changeCursor("hovered")}
                onMouseLeave={() => changeCursor("")}
                className="contact-title"
              >
                contact contact contact contact &nbsp;
              </motion.span>
            )}
          </motion.div>
          <motion.div className="contact-txt uppercase title second">
            {width > 768 ? (
              <motion.span
                onMouseEnter={() => changeCursor("hovered")}
                onMouseLeave={() => changeCursor("")}
                className="contact-title"
              >
                contact contact contact contact contact contact &nbsp;
              </motion.span>
            ) : (
              <motion.span
                onMouseEnter={() => changeCursor("hovered")}
                onMouseLeave={() => changeCursor("")}
                className="contact-title"
              >
                contact contact contact contact &nbsp;
              </motion.span>
            )}
          </motion.div>
        </motion.div>
      </motion.section>
      <Footer contain />
    </>
  )
}

export default About
